
import { css } from 'lit';
export default css`
pc-inquiries-hero{
  color:var(--primary-eggplant);
  font-family:var(--ff-body);
}
  pc-inquiries-hero [slot='right'],
  pc-inquiries-hero [slot='left']{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-4);
  }
  @media (min-width: 992px){
  pc-inquiries-hero [slot='right'],
  pc-inquiries-hero [slot='left']{
      padding:var(--spacing-12) var(--spacing-16)
  }
  pc-inquiries-hero [slot='right']{
      padding-right:var(--spacing-40);
      padding-left:var(--spacing-0)
  }
    }
  pc-inquiries-hero .media,
  pc-inquiries-hero .title{
    font-size:var(--fs-sm);
    font-style:normal;
    font-weight:var(--fw-medium);
    line-height:115%;
    letter-spacing:0.98px;
    text-transform:uppercase;
  }
  pc-inquiries-hero .title{
    margin-top:0.5rem;
  }
  pc-inquiries-hero .name{
    font-size:22px;
    font-weight:var(--fw-medium);
    line-height:120%;
  }
  pc-inquiries-hero .contact{
    padding-bottom:var(--spacing-4);
    padding-top:var(--spacing-4);
    gap:var(--spacing-8);
    display:flex;
  }
`;